// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071404/js/" + chunkId + "." + {"44":"46aaf43f","225":"af943990","481":"e7696ede","486":"9a89bd6d","770":"5e54bc66"}[chunkId] + ".0.8369058195239464.chunk.js";
};